import styled from "styled-components"
import colors from "~constants/colors"
import { rgba } from "polished"

export const ModalTextarea = styled.textarea`
  background-color: white;
  border: none;
  border-bottom: 1px solid ${colors.gray2};
  color: ${colors.blue3};
  display: block;
  height: 100px;
  letter-spacing: 0.81px;
  outline: none;
  padding: 5px 10px 0 10px;
  resize: none;
  max-width: 100%;

  &::placeholder {
    font-weight: normal;
  }

  &:disabled,
  &:disabled::placeholder {
    color: ${rgba(colors.gray6, 0.36)};
  }

  &:focus {
    border-bottom-color: ${colors.caribbean};
  }

  &.error {
    color: ${colors.red};
    border-bottom-color: ${colors.red};

    &:focus {
      border-bottom-color: ${colors.red};
    }
  }
`
